<header class="landscape-topbar">
  <button type="button" class="landscape-icon-btn" (click)="back.emit()" aria-label="Kembali">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
  </button>

  <div class="landscape-brand">
    <span class="landscape-logo" [class.has-logo]="!!logoUrl">
      <img *ngIf="logoUrl; else textLogo" [src]="logoUrl" alt="Logo perusahaan" />
      <ng-template #textLogo>Fr</ng-template>
    </span>
    <span>
      <strong>FRANTINCO AI VISUALIZER</strong>
      <small>{{ activeRoomTitle || activeRoomSummary }}</small>
    </span>
  </div>

</header>

<div class="landscape-actions" [class.panel-open]="catalogOpen || adjustmentOpen">
  <button type="button" class="landscape-icon-btn" (click)="toggleOrientation.emit()" aria-label="Ubah orientasi">
    <mat-icon aria-hidden="true">screen_rotation</mat-icon>
    <strong>Ubah orientasi</strong>
  </button>
  <label class="landscape-icon-btn" aria-label="Ganti foto">
    <input type="file" accept="image/png,image/jpeg,image/webp" (change)="roomUpload.emit($event)" />
    <mat-icon aria-hidden="true">add_a_photo</mat-icon>
    <strong>Unggah foto</strong>
  </label>
</div>

<nav
  class="landscape-bottom-nav"
  [class.has-adjustment]="hasActiveProduct"
  [class.has-used-products]="hasUsedProducts"
  [class.overlay-open]="catalogOpen || adjustmentOpen"
  aria-label="Navigasi visualizer landscape"
>
  <button type="button" [class.active]="catalogOpen" [disabled]="!canOpenCatalog || catalogOpen" (click)="toggleCatalog.emit()">
    <mat-icon aria-hidden="true">inventory_2</mat-icon>
    <strong>Daftar produk</strong>
  </button>
  <button type="button" [disabled]="!canSendToEstimator" (click)="requestQuote.emit()">
    <mat-icon aria-hidden="true">request_quote</mat-icon>
    <strong>Minta penawaran</strong>
  </button>
  <button type="button" [disabled]="!canSendToEstimator" (click)="sendToEstimator.emit()">
    <mat-icon aria-hidden="true">send</mat-icon>
    <strong>Kirim ke Estimator</strong>
  </button>
  <button type="button" *ngIf="hasActiveProduct" [class.active]="adjustmentOpen" [disabled]="adjustmentOpen" (click)="toggleAdjustment.emit()">
    <mat-icon aria-hidden="true">tune</mat-icon>
    <strong>Atur</strong>
  </button>
</nav>
